export default __webpack_public_path__ + "static/media/ic_cart.edaf6b68.svg";